export const subbrandToolHelper = {
  data() {
    return {}
  },
  computed: {
    isEditFlow() {
      let editFlow = this.$store.state.appStore.editFlow
      let publishedStatus = this.$store.state.appStore.selectedSubbrandInfo
        .status
      let isEditFlow = false
      if (editFlow && publishedStatus != 7) {
        isEditFlow = true
      }
      return isEditFlow
    }
  },
  methods: {
    handle_function_call(methodName, args) {
      var self = this
      self[methodName](args)
    },
    updateEditStatus() {
      this.$store.state.createSubbrandStore.subbrandDataChanged = true;
    },
    envMapping(item) {
      let status = item.status
      let state = item.state
      var stringObj = {};
      if (state == 1) {
        stringObj = {
          stateName: 'Draft',
          buttonText: 'Private'
        }
      } else if (state == 2 &&
        (status == 1 ||
          status == 3)) {
        stringObj = {
          stateName: 'Private',
          buttonText: 'Private'
        }
      } else if (state == 2 &&
        status == 5) {
        stringObj = {
          stateName: 'Private',
          buttonText: 'Public'
        }
      } else if (state == 3 &&
        (status == 2 ||
          status == 4 ||
          status == 6)) {
        stringObj = {
          stateName: 'Public',
          buttonText: 'Public'
        }
      }
      if (state == 1 || state == 2 || state == 3) {
        if (status == 7 || status == 5 || status == 6) {
          stringObj.disabled = false
        } else if (status == 3 || status == 4) {
          stringObj.message = true
        } else {
          stringObj.disabled = true
        }
        if (state == 3 && status == 6) {
          stringObj.disableProd = true
        }
      }
      return stringObj;
    }
  }
}